import React, { useEffect, useState, useCallback } from 'react';
import './OrderSuccess.css';
import BASE from '../api';

function itemStatusLabel(status) {
  if (status === 'cooking') return { text: '製作中', cls: 'status-cooking' };
  if (status === 'ready' || status === 'done') return { text: '完成', cls: 'status-ready' };
  return { text: '等待中', cls: 'status-pending' };
}

export default function OrderSuccess({ order, onAddMore }) {
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchOrder = useCallback(async () => {
    if (!order || !order.id) return;
    try {
      const res = await fetch(`${BASE}/api/orders/${order.id}`);
      if (!res.ok) throw new Error(`HTTP error! status: ${res.status}`);
      const data = await res.json();
      setOrderDetails(data);
      setLoading(false);
    } catch (err) {
      console.error('Failed to fetch order details:', err);
      setError(err.message);
      setLoading(false);
    }
  }, [order]);

  useEffect(() => {
    fetchOrder();
    const t = setInterval(fetchOrder, 4000);
    return () => clearInterval(t);
  }, [fetchOrder]);

  if (!order) {
    return (
      <div className="success-page">
        <div className="success-card">
          <div className="error-display">
            <div className="success-icon">❌</div>
            <h2 className="success-title">錯誤</h2>
            <p className="success-sub">訂單信息丟失</p>
            <button className="back-btn" onClick={onAddMore}>返回菜單</button>
          </div>
        </div>
      </div>
    );
  }

  const allDone = orderDetails?.items?.every(
    item => item.item_status === 'ready' || item.item_status === 'done'
  );
  const anyCooking = orderDetails?.items?.some(item => item.item_status === 'cooking');


  return (
    <div className="screen-view">
      <div className="success-page">
        <div className="success-card">
          {loading ? (
            <div className="loading">載入中...</div>
          ) : error ? (
            <div className="error-display">
              <div className="success-icon">❌</div>
              <h2 className="success-title">載入失敗</h2>
              <p className="success-sub">無法載入訂單詳情：{error}</p>
              <button className="back-btn" onClick={onAddMore}>返回菜單</button>
            </div>
          ) : (
            <>
              <div className="success-icon">
                {allDone ? '🍽️' : anyCooking ? '👨‍🍳' : '✅'}
              </div>
              <h2 className="success-title">
                <span className={`success-table${order.table_number === 'out' ? ' success-table-out' : ''}`}>{order.table_number === 'out' ? `外帶 #${order.takeout_seq ?? '?'}` : order.table_number}</span>
                訂單已送出！
              </h2>

              <div className="kitchen-status-banner">
                {allDone
                  ? '所有餐點已完成，請稍候送達'
                  : anyCooking
                    ? '廚房製作中，請稍候...'
                    : '廚房已收到訂單，即將開始製作'}
              </div>

              <div className="order-info">
                <div className="order-row">
                  <span>餐點內容</span>
                </div>
                <div className="item-details">
                  {orderDetails?.items?.length > 0 ? (
                    orderDetails.items.map((item, idx) => {
                      const { text, cls } = itemStatusLabel(item.item_status);
                      return (
                        <div key={idx} className="item-detail-row">
                          <span className="item-name">
                            {item.name}
                            {item.size && ` (${item.size === 'S' ? '小' : '中'})`}
                          </span>
                          <span className="item-qty">x{item.quantity}</span>
                          <span className={`item-kitchen-status ${cls}`}>{text}</span>
                        </div>
                      );
                    })
                  ) : (
                    <div className="item-detail-row">
                      <span className="item-name">無餐點資料</span>
                    </div>
                  )}
                </div>
                {orderDetails.note && (
                  <div className="order-row">
                    <span>備註</span>
                    <span>{orderDetails.note}</span>
                  </div>
                )}
                <div className="order-row total-row">
                  <span>合計金額</span>
                  <span className="success-total">${Number(orderDetails.total).toLocaleString()}</span>
                </div>
              </div>

              <div className="button-group">
                {order.status !== 'paid' && <button className="back-btn" onClick={onAddMore}>+ 加訂</button>}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
